import {Deserializable} from '../deserializable';
import {Staffs} from '../staff/staffs';
import {YeuCauFile} from './yeucaufile';
import {YeuCauFileNXL} from './yeucaufilenxl';

export  class YeuCauXuLy implements Deserializable
{
  public  id: number;
  public  maYeuCau: number;
  public  chuDe: string;
  public  noiDung: string;
  public  traLoi: string;
  public  thoiGianGui: string;
  public  ngayGui: string;
  public  thoiGianHoanThanh: string;
  public  maNguoiXuLy: number;
  public  nguoiXuLy: Staffs;
  public  maNguoiChuTri: number;
  public  nguoiChuTri: Staffs;
  public  trangThai: number;
  public  xem: number;
  public  xepLoai: number;
  public  ghiChu: string;
  public  maNguoiDG: number;
  public usersWrite: string;
  public  soLanDoc: number;
  public thoiGianXemLanDau: string;
  public thoiGianXemLanCuoi: string;
  public  yeuCauFiles: YeuCauFile[];
  public  receivedDate: Date;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.nguoiChuTri = input.nguoiChuTri !=null? new Staffs().deserialize(input.nguoiChuTri): null;
    this.nguoiXuLy = input.nguoiXuLy !=null? new Staffs().deserialize(input.nguoiXuLy): null;
    this.yeuCauFiles = input.yeuCauFiles != null? input.yeuCauFiles.map(yeuCauFiles => new YeuCauFile().deserialize(yeuCauFiles)): [];
    return this;
  }
}
